import { render, staticRenderFns } from "./yinhai.vue?vue&type=template&id=044ba792&scoped=true&"
import script from "./yinhai.vue?vue&type=script&lang=ts&"
export * from "./yinhai.vue?vue&type=script&lang=ts&"
import style0 from "./yinhai.vue?vue&type=style&index=0&id=044ba792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ba792",
  null
  
)

export default component.exports